module.exports = __webpack_public_path__ + "img/34889a366f6044159eb9dd21e32a2ad4-1024.b16f6083.jpg";